module.exports = __webpack_public_path__ + "static/media/its-all-come-to-this.tar.5a4561b6.gz";